import { render } from "./EditPoint.vue?vue&type=template&id=0add9f82&scoped=true"
import script from "./EditPoint.vue?vue&type=script&lang=js"
export * from "./EditPoint.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./EditPoint.vue?vue&type=style&index=1&id=0add9f82&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0add9f82"]])

export default __exports__